/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  DeviceCommandLog,
  ResponseStatusType,
} from '..';
import {
  serializeDeviceCommandLog,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface InsertDeviceCommandLogInput {
  input?: DeviceCommandLog;
}
const build = (_query: DocumentNode, input: InsertDeviceCommandLogInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.input !== undefined ? `$input: DeviceCommandLog = ${serializeDeviceCommandLog(input.input)}` : '' ) + `){
    insertDeviceCommandLog(
      ${ input.input !== undefined ? 'input: $input,' : '' }
    ){
      ...responsestatustype
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class InsertDeviceCommandLogMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment responsestatustype on ResponseStatusType { ... }
   */
  async execute(_query: DocumentNode, input: InsertDeviceCommandLogInput): Promise<apollo.FetchResult< { insertDeviceCommandLog: Partial<ResponseStatusType> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ insertDeviceCommandLog: Partial<ResponseStatusType> }>({ mutation: build(_query, input) });
  }
}
